(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video-once"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('#Hero-{{ section.id }}');
  if (!hero) return;

  const video = hero.querySelector('.hero__video');
  const image = hero.querySelector('.hero__image');
  let hasPlayed = false;

  if (!video) return;

  // Ensure muted autoplay is allowed
  video.muted = true;

  const playVideoOnce = () => {
    if (hasPlayed) return;
    hasPlayed = true;

    video.style.opacity = '1';
    video.play().then(() => {
      video.addEventListener('ended', () => {
        video.remove(); // remove video after finish
        if (image) image.style.opacity = '1';
      });
    }).catch(err => {
      console.warn('Autoplay blocked:', err);
      video.remove();
      if (image) image.style.opacity = '1';
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        playVideoOnce();
        observer.unobserve(hero);
      }
    });
  }, { threshold: 0.2 });

  observer.observe(hero);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const slideshow = document.querySelector('.slideshow');
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll('.slideshow__video');
  let currentIndex = 0;
  let isSpeededUp = false;

  // Hide all but first
  slides.forEach((vid, i) => {
    vid.pause();
    vid.style.display = i === 0 ? 'block' : 'none';
  });

  const playVideo = (index, speed = 1) => {
    const video = slides[index];
    if (!video) return;

    video.playbackRate = speed;
    video.currentTime = 0;
    video.play();
    video.style.display = 'block';

    // Hide others
    slides.forEach((v, i) => {
      if (i !== index) {
        v.pause();
        v.style.display = 'none';
      }
    });

    video.onended = () => {
      currentIndex = (currentIndex + 1) % slides.length;
      isSpeededUp = false;
      playVideo(currentIndex, 1);
    };
  };

  playVideo(currentIndex, 1);

  // Click anywhere to advance / speed up
  slideshow.addEventListener('click', () => {
    const currentVideo = slides[currentIndex];
    if (!currentVideo) return;

    if (currentVideo.paused) {
      playVideo(currentIndex, 1);
    } else if (!isSpeededUp && !currentVideo.ended) {
      currentVideo.playbackRate = 2;
      isSpeededUp = true;
    } else if (isSpeededUp) {
      return;
    } else if (currentVideo.ended) {
      currentIndex = (currentIndex + 1) % slides.length;
      isSpeededUp = false;
      playVideo(currentIndex, 1);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
